import React from 'react';
import * as Styled from '../styles';
import { CellProps } from '../types';

export const DefaultCell = ({ val }: CellProps) => (
  <Styled.CellWrapper>
    {val}
  </Styled.CellWrapper>
);
